import { render, staticRenderFns } from "./ReviewContract.vue?vue&type=template&id=0d163cd2&scoped=true&"
import script from "./ReviewContract.vue?vue&type=script&lang=js&"
export * from "./ReviewContract.vue?vue&type=script&lang=js&"
import style0 from "./ReviewContract.vue?vue&type=style&index=0&id=0d163cd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d163cd2",
  null
  
)

export default component.exports